// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { Icon } from '@lmc/ui-kit'
import { Menu } from 'antd'
import { css, StyleSheet } from 'aphrodite/no-important'
import PropTypes from 'prop-types'
import React from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { Link } from 'react-router-dom'
import AntdDropdown from '../AntdDropdown/AntdDropdown'

const isDesktop = isBrowser || isTablet

const Label = (props) => {
  const { isActive, labelTitle, mobileIcon, open, setOpen } = props

  const iconName = open ? 'UpOutlined' : 'DownOutlined'

  const mobileIconStyle = { ...(isActive && { color: colors.pink }) }

  return (
    <div className={css(classes.label)} onClick={() => setOpen(!open)}>
      {isDesktop || !mobileIcon ? (
        <div>{labelTitle}</div>
      ) : (
        <Icon name={mobileIcon} style={mobileIconStyle} />
      )}
      <Icon name={iconName} style={styles.arrow} />
    </div>
  )
}

const handleSelect = (props) => {
  const { open, setOpen } = props

  setOpen(!open)
}

export default function TabBarDropdown(props) {
  const { baseUrl, dropdownPlacement, isActive, menuItems } = props

  const [open, setOpen] = React.useState(false)

  const containerStyle = {
    ...styles.container,
    borderBottom: `3px solid ${isActive ? colors.pink : 'transparent'}`
  }

  return (
    <div style={containerStyle}>
      <AntdDropdown
        label={<Label {...props} open={open} setOpen={setOpen} />}
        onOpenChange={() => setOpen(!open)}
        placement={dropdownPlacement}
        trigger="click"
      >
        <Menu
          style={styles.menu}
          onClick={() => handleSelect({ open, setOpen })}
        >
          {menuItems.map((item) => {
            return (
              <Menu.Item key={item.label}>
                <Link
                  style={styles.link}
                  to={item.url ? `${baseUrl}/${item.url}` : baseUrl}
                >
                  {item.label}
                </Link>
              </Menu.Item>
            )
          })}
        </Menu>
      </AntdDropdown>
    </div>
  )
}

TabBarDropdown.propTypes = {
  baseUrl: PropTypes.string,
  dropdownPlacement: PropTypes.string,
  isActive: PropTypes.bool,
  labelTitle: PropTypes.string,
  menuItems: PropTypes.array.isRequired
}

const classes = StyleSheet.create({
  label: {
    display: 'flex',
    alignItems: 'center',
    padding: '.75em 1em .65em',
    ':hover': {
      cursor: 'pointer',
      color: colors.pink
    }
  }
})

const styles = {
  arrow: {
    marginLeft: 8
  },
  container: {
    alignItems: 'center',
    display: 'flex'
  },
  link: {
    textDecoration: 'none'
  },
  menu: {
    boxShadow: '0 1px 3px hsla(0, 0%, 0%, 0.1), 0 -1px 3px hsla(0, 0%, 0%, 0.1)'
  }
}
